import { createContext, useContext, useState } from "react"

const AuthContext = createContext()

function AuthProvider(props) {
    const [user, setUser] = useState(null)
    const [activeVerificationCode, setActiveVerificationCode] = useState(null) //save user id

    function updateUser(newUser) {
        setUser(newUser)
    }

    function updateVerificationCode(newStatus) {
        setActiveVerificationCode(newStatus)
    }

    const value = {
        user,
        activeVerificationCode,
        updateUser,
        updateVerificationCode,
    }

    return (
        <AuthContext.Provider value={value} {...props} />
    )
}

function useAuth() {
    return useContext(AuthContext)
}

export { AuthProvider, useAuth }